var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { SeverityLevel } from '@logz-pkg/enums';
import { Expose, Transform } from 'class-transformer';
export class TriggeredAlertModel {
    definitionId;
    condition;
    description;
    eventId;
    groupByIds;
    fromDate;
    toDate;
    title;
    severity;
    isMuted;
    hits;
    investigateUrlParams;
    subComponentIndex;
    timeRangeInMinutes;
}
__decorate([
    Expose({ name: 'logzio-alert-definition-id' }),
    __metadata("design:type", Number)
], TriggeredAlertModel.prototype, "definitionId", void 0);
__decorate([
    Expose({ name: 'logzio-alert' }),
    __metadata("design:type", String)
], TriggeredAlertModel.prototype, "condition", void 0);
__decorate([
    Expose({ name: 'logzio-alert-description' }),
    __metadata("design:type", String)
], TriggeredAlertModel.prototype, "description", void 0);
__decorate([
    Expose({ name: 'logzio-alert-event-id' }),
    __metadata("design:type", String)
], TriggeredAlertModel.prototype, "eventId", void 0);
__decorate([
    Expose({ name: 'logzio-alert-group-ids' }),
    Transform(object => object ?? {}),
    __metadata("design:type", Object)
], TriggeredAlertModel.prototype, "groupByIds", void 0);
__decorate([
    Expose({ name: 'logzio-alert-timerange-start' }),
    __metadata("design:type", String)
], TriggeredAlertModel.prototype, "fromDate", void 0);
__decorate([
    Expose({ name: 'logzio-alert-timerange-end' }),
    __metadata("design:type", String)
], TriggeredAlertModel.prototype, "toDate", void 0);
__decorate([
    Expose({ name: 'logzio-alert-title' }),
    __metadata("design:type", String)
], TriggeredAlertModel.prototype, "title", void 0);
__decorate([
    Expose({ name: 'logzio-alert-triggered-severity' }),
    __metadata("design:type", String)
], TriggeredAlertModel.prototype, "severity", void 0);
__decorate([
    Expose({ name: 'logzio-event-muted' }),
    __metadata("design:type", Boolean)
], TriggeredAlertModel.prototype, "isMuted", void 0);
__decorate([
    Expose({ name: 'logzio-hits' }),
    __metadata("design:type", Number)
], TriggeredAlertModel.prototype, "hits", void 0);
__decorate([
    Expose({ name: 'logzio-investigate' }),
    __metadata("design:type", String)
], TriggeredAlertModel.prototype, "investigateUrlParams", void 0);
__decorate([
    Expose({ name: 'logzio-sub-component-index' }),
    __metadata("design:type", Number)
], TriggeredAlertModel.prototype, "subComponentIndex", void 0);
__decorate([
    Expose({ name: 'lozgio-time-range-in-minutes' }),
    __metadata("design:type", Number)
], TriggeredAlertModel.prototype, "timeRangeInMinutes", void 0);
//# sourceMappingURL=triggered-alert.js.map